import { Checkbox } from "~/components/ui/checkbox";
import { Input } from "~/components/ui/input";
import { Label } from "~/components/ui/label";

type OptionalEmailFieldsProps = {
  email: string;
  emailError?: string | null;
  id: string;
  newsletterOptIn: boolean;
  onEmailChange: (value: string) => void;
  onNewsletterOptInChange: (checked: boolean) => void;
};

export function OptionalEmailFields({
  email,
  emailError,
  id,
  newsletterOptIn,
  onEmailChange,
  onNewsletterOptInChange,
}: OptionalEmailFieldsProps) {
  const errorId = `${id}-error`;

  return (
    <div className="max-w-xl space-y-4">
      <div className="space-y-2">
        <Label htmlFor={id} className="text-sm font-medium text-foreground">
          Email adresa{" "}
          <span className="font-normal text-muted-foreground">(opciono)</span>
        </Label>
        <Input
          id={id}
          type="email"
          autoComplete="email"
          value={email}
          onChange={(event) => onEmailChange(event.target.value)}
          placeholder="tvoj@email.com"
          aria-describedby={emailError ? errorId : undefined}
          className="h-14 rounded-md border-border bg-background px-4 text-base shadow-none focus-visible:ring-brand"
        />
      </div>
      {emailError && (
        <p id={errorId} className="text-sm text-destructive" role="alert">
          {emailError}
        </p>
      )}
      <Label className="flex cursor-pointer items-start gap-3 border-y border-border py-4 text-sm leading-6 text-muted-foreground">
        <Checkbox
          checked={newsletterOptIn}
          onCheckedChange={(checked) =>
            onNewsletterOptInChange(checked === true)
          }
          className="mt-0.5 shrink-0 border-brand data-[state=checked]:bg-brand-action data-[state=checked]:text-white"
        />
        Želim da dobijam praktične savete o psihoterapiji i ponude Rešimo
        Probleme.
      </Label>
    </div>
  );
}
